import type { TreePickerItem } from './TreePickerItem';

export const countLeaves = <TKey extends string>(
  items: TreePickerItem<TKey>[],
): number =>
  items.reduce(
    (acc, item) =>
      item.children.length === 0 ? acc + 1 : acc + countLeaves(item.children),
    0,
  );
